import React, { useState, useEffect, useCallback } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined, SafetyCertificateOutlined, ReloadOutlined } from '@ant-design/icons';
import { getCaptcha, login } from '../services/api';

const Login = ({ onLoginSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [captchaImage, setCaptchaImage] = useState('');
  const [captchaLoading, setCaptchaLoading] = useState(false);

  // 获取验证码图片
  const refreshCaptcha = useCallback(async () => {
    setCaptchaLoading(true);
    try {
      const response = await getCaptcha();
      if (response.success) {
        setCaptchaImage(response.image);
      }
    } catch (error) {
      console.error('获取验证码失败:', error);
      message.error('验证码加载失败，请刷新重试');
    } finally {
      setCaptchaLoading(false);
    }
  }, []);

  // 首次加载获取验证码
  useEffect(() => {
    refreshCaptcha();
  }, [refreshCaptcha]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await login({
        account: values.account,
        password: values.password,
        captcha_code: values.captcha_code,
      });

      if (response.success) {
        message.success('登录成功！');
        onLoginSuccess(response.username);
      } else {
        message.error(response.message || '登录失败');
        refreshCaptcha();
      }
    } catch (error) {
      console.error('登录错误:', error);
      if (error.response) {
        message.error(error.response.data.message || '登录失败');
      } else {
        message.error('网络错误，请检查后端服务');
      }
      // 登录失败刷新验证码
      refreshCaptcha();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #1890ff 0%, #0050b3 100%)',
      }}
    >
      <Card
        style={{
          width: 420,
          boxShadow: '0 8px 24px rgba(24, 144, 255, 0.2)',
          borderRadius: 8,
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 56,
              height: 56,
              marginBottom: 12,
              borderRadius: 12,
              background: 'linear-gradient(135deg, #1890ff 0%, #0050b3 100%)',
              boxShadow: '0 4px 12px rgba(24, 144, 255, 0.3)',
            }}
          >
            <SafetyCertificateOutlined style={{ fontSize: 28, color: '#fff' }} />
          </div>
          <h1 style={{ fontSize: 26, fontWeight: 600, color: '#1890ff', marginBottom: 4 }}>
            供需罗盘 · 门店版
          </h1>
          <p style={{ color: '#999', fontSize: 13 }}>请登录以继续访问</p>
        </div>

        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="account"
            rules={[{ required: true, message: '请输入账号！' }]}
          >
            <Input
              prefix={<UserOutlined style={{ color: '#1890ff' }} />}
              placeholder="用户名 / 手机号 / 邮箱"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码！' }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: '#1890ff' }} />}
              placeholder="密码"
            />
          </Form.Item>

          <div style={{ display: 'flex', gap: 8 }}>
            <Form.Item
              name="captcha_code"
              rules={[{ required: true, message: '请输入验证码！' }]}
              style={{ flex: 1, marginBottom: 24 }}
            >
              <Input
                prefix={<SafetyCertificateOutlined style={{ color: '#1890ff' }} />}
                placeholder="验证码"
                maxLength={4}
              />
            </Form.Item>
            <div
              onClick={refreshCaptcha}
              title="点击刷新验证码"
              style={{
                width: 150,
                height: 44,
                borderRadius: 6,
                overflow: 'hidden',
                cursor: 'pointer',
                border: '1px solid #d9d9d9',
                background: '#f5f5f5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              {captchaLoading ? (
                <ReloadOutlined spin style={{ color: '#1890ff' }} />
              ) : captchaImage ? (
                <img
                  src={captchaImage}
                  alt="验证码"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              ) : (
                <span style={{ color: '#999', fontSize: 12 }}>点击获取</span>
              )}
            </div>
          </div>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{ height: 42, background: '#1890ff', borderColor: '#1890ff' }}
            >
              登录
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center', color: '#bbb', fontSize: 12 }}>
        </div>
      </Card>
    </div>
  );
};

export default Login;
